export interface DeviceLiveState {
  locked?: boolean | null;
  dpsOpen?: boolean | null;
  relayOpen?: boolean | null;
  communicationLost?: boolean | null;
  rexOn?: boolean | null;
  features?: string[];
  firmware_version?: string | null;
  fetched_at?: string;
  observed_at?: string;
  unavailable_reason?: string | null;
}

/** Adapt the existing `/devices/:id/status` contract for the detail modal. */
export function adaptDeviceStatusResponse(payload: Record<string, any>, fetchedAt = new Date().toISOString()): DeviceLiveState {
  const online = typeof payload.online === 'boolean'
    ? payload.online
    : String(payload.connection_status || '').toLowerCase() === 'online';
  return {
    communicationLost: !online,
    firmware_version: payload.firmware_version || null,
    fetched_at: fetchedAt,
    observed_at: payload.last_seen || payload.last_seen_at || null,
    unavailable_reason: payload.integration_error || null,
  };
}

